var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5396 0.824418C19.5556 0.469418 20.5316 1.44542 20.1766 2.46142L14.2516 19.3914C13.8666 20.4894 12.3366 20.5514 11.8646 19.4884L9.00561 13.0564L13.0296 9.03142C13.1621 8.88924 13.2342 8.7012 13.2308 8.5069C13.2274 8.31259 13.1486 8.12721 13.0112 7.9898C12.8738 7.85238 12.6884 7.77367 12.4941 7.77024C12.2998 7.76681 12.1118 7.83894 11.9696 7.97142L7.94461 11.9954L1.51261 9.13642C0.449611 8.66342 0.51261 7.13442 1.60961 6.74942L18.5396 0.824418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.3a8f2ef4a9a7f237276d75044916c97f.svg";
export { ForwardRef as ReactComponent };